import React from "react";
import styled from "@emotion/styled";
import { DateTime } from "luxon";
import { Typography } from "../Typography";

const SlideWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-flow: column;

  @media ${(props) => props.theme.bp.desktopUp} {
    height: 480px;
    flex-flow: row-reverse;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px 24px;
  background-color: ${(props) => props.theme.colors.mist};
  flex: 1;
`;

const ImageWrapper = styled.div`
  overflow: hidden;
  height: 194px;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center center;
  }

  @media ${(props) => props.theme.bp.desktopUp} {
    flex: 1;
    height: 100%;
  }

  @media ${(props) => props.theme.bp.dashboardPageDesktop} {
    flex: 2;
  }
`;

const SlideTitle = styled(Typography)`
  margin-bottom: 16px;
`;

const SlideDate = styled(Typography)`
  margin-bottom: 16px;
  color: ${(props) => props.theme.colors.charcoal};
`;

const SlideDescription = styled(Typography)`
  margin-bottom: 16px;
`;

const LocationWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
`;

const LocationMarker = styled.img`
  margin-right: 16px;
`;

export interface ProjectUpdateSlideProps {
  title: string;
  date: Date;
  description: string;
  image: {
    src: string;
    alt: string;
  };
  projectUrl: string;
  projectLocation: string;
}

export const ProjectUpdateSlide = ({
  title,
  date,
  description,
  image,
  projectUrl,
  projectLocation,
}: ProjectUpdateSlideProps) => {
  return (
    <SlideWrapper>
      <ImageWrapper>
        <img src={image.src} alt={image.alt} />
      </ImageWrapper>
      <ContentWrapper>
        <div>
          <SlideTitle use="componentTitle" as="h2">
            {title}
          </SlideTitle>
          <SlideDate use="caption" as="p">
            {DateTime.fromJSDate(date).toFormat("dd LLL yyyy")}
          </SlideDate>
          <SlideDescription use="body1" as="p">
            {description}
          </SlideDescription>
          <Typography
            use="standaloneLink"
            as="a"
            href={projectUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit project page
          </Typography>
        </div>
        {projectLocation && (
          <LocationWrapper>
            <LocationMarker
              src="/images/app/map/marker-red.svg"
              alt=""
              width="21"
              height="28"
            />
            <Typography use="body1">{projectLocation}</Typography>
          </LocationWrapper>
        )}
      </ContentWrapper>
    </SlideWrapper>
  );
};
